import React, { Component } from 'react';
import CustomLink from '@gerenciatd/next.components.custom-link';
import TextInfo from '@gerenciatd/next.components.text-info-n';
import Button from '@gerenciatd/next.components.button-n';

export const SCX_PATH = `https://{env}.cms.col.movistar.es/static/js/scx/scx.js`
const COMPONENT_NAME = 'SimplePhone';

const isProperrSchedule = () => {
  const horaActual = new Date();
  const horaInicio = new Date();
  const horaFin = new Date();
  
  // Establecer la hora de inicio en 9:00 AM
  horaInicio.setHours(9);
  horaInicio.setMinutes(0);
  horaInicio.setSeconds(0);

  // Establecer la hora de finalización en 8:00 PM
  horaFin.setHours(20);
  horaFin.setMinutes(0);
  horaFin.setSeconds(0);

  // Verificar si la hora actual está dentro del rango
  return horaActual >= horaInicio && horaActual <= horaFin;
}
class SimplePhone extends Component {
  constructor(props){
    super(props);
    let schedule = true;
    if (typeof window !== 'undefined'){
      schedule = isProperrSchedule();
    }
    this.state={
      schedule,
    }
  }

  handleClick = () => {
    let loadjs = null;
    let env = 'prod';
    if (`${process.env.NEXT_PUBLIC_ENV_NAME}` !== env) {
      env = 'qa'
    }
    const scxRoute = SCX_PATH.replace('{env}', env);
    import('loadjs').then(module => {
      loadjs = module.default;
      if (window && !window.SCX){
        loadjs(scxRoute, { async: true, returnPromise: true }).then(() => {
          window.SCX.setReactEnviroment();
          window.SCX.launchModalC2C();
        });
      } 
      if (window && window.SCX) {
        window.SCX.launchModalC2C();
      }
    })
  }

  render() {
    const { schedule } = this.state;
    if (!schedule) {
      return null;
    }
    const {
      phoneNumber,
      kind="phone",
      buttonType="secondary",
      label,
      color,
      size,
      fontType,
      taggingInfo,
    } = this.props;

    if(kind === 'phone'){
      return (
        <>
        <CustomLink
          className="mainPhoneCTA"
          href={`tel:+34${phoneNumber}`}
          taggingInfo={{
            ...taggingInfo,
            componentName: taggingInfo.componentName || COMPONENT_NAME,
            componentContent: `${label} al ${phoneNumber}`,
            componentVariation: kind
          }} >
            <TextInfo
              size={size}
              color={color}
              fontType={fontType}
              text={`${label} ${phoneNumber}`}
              display="inline"
            />
        </CustomLink>
        <style jsx>
              {`
                :global(.mainPhoneCTA) {
                  position: relative;
                  z-index: 2;
                }
              `}
            </style>
        </>
      )
    }
  
    return (
      <Button 
        buttonType={buttonType}
        label={label}
        onClick={this.handleClick}
        buttonWidth="full"
        taggingInfo={{
          ...taggingInfo,
          componentName: taggingInfo.componentName || COMPONENT_NAME,
          componentComponent: label,
          componentVariation: kind
        }}
      />
    )
  }
} 


export default SimplePhone;